import {Injectable} from '@angular/core';
import {take} from "rxjs/operators";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ModalService} from "./modal.service";
import {ConsentService} from "./consent.service";
import {ContactInfoService} from "./contact-info.service";
import {UserInfoService} from "./user-info.service";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserConsentService {

  public isPrescriptionConsentAndTermsAcceptedSubject = new BehaviorSubject<boolean>(false);
  isPrescriptionConsentAndTermsAccepted$ = this.isPrescriptionConsentAndTermsAcceptedSubject.asObservable();

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private consentService: ConsentService,
    private contactInfoService: ContactInfoService,
    private userInfoService: UserInfoService
  ) {
    this.checkConsentStatus();
  }

  createPrescriptionConsentForm(): FormGroup {
    return this.fb.group({
      prescriptionTerms: [false]
    });
  }

  subscribeToPrescriptionTermsChanges(prescriptionsConsentForm: FormGroup) {
    prescriptionsConsentForm.get('prescriptionTerms').valueChanges.subscribe();
  }

  showModalAndHandleConsent(
    prescriptionsConsentForm: FormGroup,
    formControlName: string
  ): void {
    const previousCheckboxState = prescriptionsConsentForm.get(formControlName).value;
    this.modalService.showPrescriptionConsentModal(true, previousCheckboxState);

    this.modalService.modalCanceled.pipe(take(1)).subscribe((canceled) => {
      prescriptionsConsentForm.patchValue({[formControlName]: canceled});
    });

    this.modalService.consentModalClosed.pipe(take(1)).subscribe((result) => {
      if (result && result.termsText !== null) {
        prescriptionsConsentForm.get(formControlName).setValue(result.termsText.accepted);

        this.consentService.updateConsent(prescriptionsConsentForm.get(formControlName).value);
        this.contactInfoService.acceptTermsOfService(
          'SAVE_PARTIAL',
          this.userInfoService.getSessionContext().principal.id,
          prescriptionsConsentForm.get(formControlName).value,
          result.termsText.termsId,
          result.termsText.id,
          this.userInfoService.getSessionContext().termsOutput.prescriptionsConsentId,
          this.userInfoService.getSessionContext().termsOutput.prescriptionConsentReference
        ).then(() => {

          const consentContext = this.getConsentContext();
          if (consentContext && consentContext.returnedUrl.url) {
            sessionStorage.removeItem("ConsentContext");
            window.open(consentContext.returnedUrl.url, "_self");
          }
        });
      }
    });
  }

  checkConsentStatus(): void {
    this.userInfoService.sessionContext$.subscribe((sessionContext) => {
      if (sessionContext && sessionContext.termsOutput) {
        const prescriptionConsent = sessionContext.termsOutput.prescriptionConsentReference;
        const isPrescriptionTermsAccepted = sessionContext.termsOutput.prescriptionsAccepted;
        const isAccepted = prescriptionConsent && prescriptionConsent.trim() !== '' && isPrescriptionTermsAccepted;
        const consentContext = this.getConsentContext();

        if (isAccepted && !(consentContext && consentContext.returnedUrl?.url)) {
          this.isPrescriptionConsentAndTermsAcceptedSubject.next(true);
        } else {
          this.isPrescriptionConsentAndTermsAcceptedSubject.next(false);
        }

      } else {
        this.isPrescriptionConsentAndTermsAcceptedSubject.next(false);
      }
    });
  }

  private getConsentContext() {
    const consentString = sessionStorage.getItem("ConsentContext");
    return JSON.parse(consentString);
  }
}
